/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MachineVariableMetricDTO { 
    nickname?: string;
    timestamp?: string;
    value?: number;
    rating?: number;
    machine_variable?: string;
    custom_unit?: string;
    original_unit?: string;
}

